<template>
  <div class="layout">
    <aside :class="['sidebar', { active: isMenuOpen }]">
      <div class="sidebar-header">
        <div class="logo"></div>
        <button class="close-btn" @click="toggleMenu">&times;</button>
      </div>
      <ul class="nav-links">
        <li><router-link to="/" @click="closeMenu">Home</router-link></li>
       <!--  <li><router-link to="/aboutus" @click="closeMenu">About Us</router-link></li> -->
        <li><router-link to="/information" @click="closeMenu">Information</router-link> </li>
        <li><router-link to="/states" @click="closeMenu">States</router-link></li>
        <li><router-link to="/categories" @click="closeMenu">Categories</router-link></li>
        <li><router-link to="/products" @click="closeMenu">Products</router-link></li>
        <li><router-link to="/taxrules" @click="closeMenu">Tax Rules</router-link></li>
        <li> <router-link to="/uploadcsvfile" @click="closeMenu" >CSV Tax Calculation  </router-link> </li>
        <li><router-link to="/taxcalculation" @click="closeMenu" >Tax Calculation</router-link></li>
        <li><router-link to="/skutaxcalculation" @click="closeMenu">SKU Tax Calculation</router-link></li>
        <li><router-link to="/pactact" @click="closeMenu"> Pact Act</router-link></li>
         <li><router-link to="/companies" @click="closeMenu"> Companies</router-link></li>
      </ul>
      <button @click="openModal" class="logout-btn">Logout</button>
    </aside>
    <header class="header">
      <button class="hamburger" @click="toggleMenu">☰</button>
      <div class="header-title" style="font-weight: bold">Dashboard</div>
        <div class="header-logo">
        <img :src="logo" alt="App Logo" />
      </div>
    </header>
    <div class="main-content" :class="{ shift: isMenuOpen }">
      <router-view />
    </div>
    <div class="modal fade" id="logoutModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Confirm Logout</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">Are you sure you want to log out?</div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cancel
            </button>
            <button type="button" class="btn btn-danger" @click="logout">Logout</button>
            <div v-if="loader" class="loader-overlay">
              <div class="loader"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { eventBus } from "../eventBus";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min";
import logo from '../assets/images/Artboard.svg'
export default {
  data() {
    return {
      logo,
      isMenuOpen: true,
      loader: false,
      dropdownOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },

    logout() {
      this.loader = true;
      setTimeout(() => {
        const modal = bootstrap.Modal.getInstance(document.getElementById("logoutModal"));
        if (modal) modal.hide();

        this.$store.dispatch("logout");
        eventBus.$emit("auth-changed");

        this.$router.push("/login").then(() => {
          window.location.reload();
        });

        this.loader = false;
      }, 1000);
    },

    openModal() {
      const modal = new bootstrap.Modal(document.getElementById("logoutModal"));
      modal.show();
    },
  },
};
</script>

<style scoped>
.layout {
  display: flex;
  height: 100vh;
}

.sidebar {
  width: 250px;
 background: linear-gradient(135deg, #2b1111, #1d5267);
  color: white;
  padding: 20px;
  position: fixed;
  top: 0;
  left: -250px;
  height: 100%;
  overflow-y: auto;
  transition: left 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 1000;
}

.sidebar.active {
  left: 0;
}

.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.logo-text {
  font-size: 20px;
  font-weight: bold;
  color: #ffd700;
}
.close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
}

.logo {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  flex-grow: 1;
}

.nav-links {
  list-style: none;
  padding: 0;
}

.nav-links li {
  margin: 10px 0;
}

.nav-links li a {
  text-decoration: none;
  color: white;
  display: block;
  padding: 10px;
  border-radius: 5px;
}

.nav-links li a:hover {
  background: #235699;
}

.logout-btn {
  background: red;
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
  border-radius: 5px;
  width: 100%;
  text-align: center;
  margin-top: auto;
}

.header {
  width: 100%;
  height: 60px;
 background: linear-gradient(135deg, #2b1111, #1d5267);
  color: white;
  display: flex;
  align-items: center;
  padding: 0 20px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}

.header-title {
  flex-grow: 1;
  text-align: center;
  font-size: 20px;
}
.header-logo img {
  height: 40px;
  width: auto;
  object-fit: contain;
  max-width: 120px;
}

.main-content {
  flex-grow: 1;
  margin-left: 0;
  padding: 80px 20px;
  transition: margin-left 0.3s ease-in-out;
  width: 100%;
  overflow-y: auto;
}

.main-content.shift {
  margin-left: 250px;
}

/* Mobile */
@media (max-width: 768px) {
  .sidebar {
    width: 100%;
    transform: translateX(-100%);
  }
  .sidebar.active {
    transform: translateX(0);
  }
  .main-content.shift {
    margin-left: 0 !important;
  }
  .header-title {
    font-size: 18px;
  }
  .header-logo img {
    height: 35px;
    max-width: 100px;
  }
}

.hamburger {
  display: block;
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loader {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
